import { combineReducers } from 'redux'

// reducer import
import authReducer from './authReducer'
import alertReducer from './alertReducer'
import downloadReducer from './downloadReducer'

// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
  auth: authReducer,
  alert: alertReducer,
  download: downloadReducer
})

export default reducer
